import VoiceCallSocketService from "../voice_call_socket_service";
import io from "socket.io-client";
import { API_BASE_URL } from "../../../../core/constants/app_constants";
import { VoiceCallRequestType } from "../../../domain/enum/voice_call_request_type";
import { VoiceCallDataType } from "../../../domain/enum/voice_call_data_type";
import { Conversation } from "@11labs/client";
import TrackingService from "../impl/tracking_service_impl";

const trackingService = new TrackingService();

class VoiceCallSocketServiceImpl extends VoiceCallSocketService {
  static #instance = null; // Private static instance

  constructor() {
    if (VoiceCallSocketServiceImpl.#instance) {
      return VoiceCallSocketServiceImpl.#instance; // Return existing instance
    }
    super();
    VoiceCallSocketServiceImpl.#instance = this; // Store instance
    this.callSocket = null;
    this.callConversation = null;
    this.conversationId = null;
    this.userId = null;
    this.chatChannelId = null;
    this.onConnected = null;
    this.onDisconnect = null;
    this.onComplete = null;
    this.onModeChange = null;
    this.onError = null;
    this.isCallEnded = false;
    this.userName = null;
  }

  connect({ userId, chatChannelId, onConnected, onDisconnected, onComplete, onModeChange, onError, userName = '' }) {
    if (this.callSocket) {
      console.log("Socket already exists");
      return;
    }

    console.log("VoiceCallSocketServiceImpl connect");

    this.userId = userId;
    this.chatChannelId = chatChannelId;
    this.onConnected = onConnected;
    this.onDisconnect = onDisconnected;
    this.onComplete = onComplete;
    this.onModeChange = onModeChange;
    this.onError = onError;
    this.isCallEnded = false;
    this.userName = userName;

    this.callSocket = io(`${API_BASE_URL}/voice-call`, {
      path: "/socket.io",
      query: {},
    });

    this.callSocket.on("connect", () => {
      console.log("Connected to /voice-call namespace with id:", this.callSocket.id);

      //Start Voice Call
      if (!this.isCallEnded) {
        trackingService.trackEvent("voice_call_initiated", { userId: this.userId, distinct_id: this.userId, timestamp: new Date().toISOString() });
        this.callSocket.emit("request", {
          type: VoiceCallRequestType.startVoiceCall,
          data: {
            userId: this.userId,
            chatChannelId: this.chatChannelId,
          },
        });
      } else {
        // trackingService.trackEvent("voice_call_ended", { userId: this.userId, distinct_id: this.userId, timestamp: new Date().toISOString() });
        this.performDisconnection();
      }
    });

    this.callSocket.on("result_notice", (payload) => {
      const { type, message, data } = payload;
      if (!this.isCallEnded) {
        switch (type) {
          case VoiceCallRequestType.startVoiceCall:
            this.connectToVoiceConversation(data[0]);
            trackingService.trackEvent("voice_call_started", { userId: this.userId, distinct_id: this.userId, timestamp: new Date().toISOString() });
            break;
          default:
            break;
        }
      } else {
        this.performDisconnection();
      }
    });

    this.callSocket.on("error_notice", (payload) => {
      const { type, message, error } = payload;
      console.log("ERROR NOTICE RECEIVED", error[0]);
      this.onError(error[0]);
      trackingService.trackEvent("voice_call_failed", { userId: this.userId, distinct_id: this.userId, failure_reason: error[0], timestamp: new Date().toISOString() });
      this.performDisconnection();
      // switch (type) {
      //     case VoiceCallRequestType.startVoiceCall:
      //         // Error result of Start Voice Call Request
      //         this.onError(error[0]);
      //         this.performDisconnection();
      //         break;
      //     case VoiceCallDataType.CallConversationConnectedData:
      //         //Error result of the call conversation data that we send
      //         this.onError(error[0]);
      //         this.performDisconnection();
      //         break;
      //     default:
      //         this.onError(error[0]);
      //         this.performDisconnection();
      //         break;
      // }
    });

    this.callSocket.on("disconnect", () => {
      console.log("Disconnected from /voice-call namespace");
      this.disconnect();
    });
  }

  disconnect() {
    console.log("VoiceCallSocketServiceImpl disconnect");
    this.isCallEnded = true;
    if (this.callConversation) {
      console.log("END CALL SESSION");
      // trackingService.trackEvent("voice_call_ended", { userId: this.userId, distinct_id: this.userId, timestamp: new Date().toISOString() });
      this.callConversation.endSession();
    } else {
      console.log("END CALL SESSION NOT FOUND, Perform disconnection");
      this.performDisconnection();
    }
  }

  async performDisconnection() {
    if (this.callSocket) {
      this.callSocket.emit("request", {
        type: VoiceCallRequestType.endVoiceCall,
        data: {
          chatChannelId: this.chatChannelId,
        },
      });
      trackingService.trackEvent("voice_call_ended", { userId: this.userId, distinct_id: this.userId, timestamp: new Date().toISOString() });
      this.callSocket.disconnect();
      if (this.onComplete) {
        this.onComplete();
      }
      this.callSocket = null;
      this.conversationId = null;
      this.userId = null;
      this.chatChannelId = null;
      this.onConnected = null;
      this.onDisconnect = null;
      this.onComplete = null;
      this.onModeChange = null;
      this.onError = null;
    }
    if (this.callConversation) {
      this.callConversation.endSession();
    }
  }

  async connectToVoiceConversation(data) {
    console.log("VoiceCallSocketServiceImpl connectToVoiceConversation", data);
    console.log("UserName", this.userName);
    if (this.isCallEnded) {
      this.performDisconnection();
    } else {
      let callConnectedSuccess = false;
      const callConversation11Labs = await Conversation.startSession({
        signedUrl: data.signedUrl,
        dynamicVariables: {
          user_name: this.userName,
        },
        onModeChange: (mode) => {
          if (this.isCallEnded) {
            // trackingService.trackEvent("voice_call_ended", { userId: this.userId, distinct_id: this.userId, timestamp: new Date().toISOString() });
            this.performDisconnection();
          } else {
            if (this.onModeChange) {
              this.onModeChange(mode.mode);
            }
          }
        },
        onConnect: () => {
          console.log("Connected to Call");
          if (this.isCallEnded) {
            this.performDisconnection();
          } else {
            if (this.onConnected) {
              this.onConnected();
            }
          }
          callConnectedSuccess = true;
        },
        onDisconnect: () => {
          console.log("Disconnected from Call");
          this.performDisconnection();
        },
        onError: (error) => {
          console.error("Call error:", error);
          trackingService.trackEvent("voice_call_failed", { userId: this.userId, distinct_id: this.userId, failure_reason: error.message, timestamp: new Date().toISOString() });
          if (this.onError) {
            this.onError(error.message);
          }
          this.performDisconnection();
        },
        onMessage: (message) => {
          if (this.isCallEnded) {
            this.performDisconnection();
          } else {
            if (message.source === "ai") {
              console.log("Agent message:", message);
              //debugMessageElement.textContent = `AI: ${message.message}`;
            }
          }
        },
      });
      this.callConversation = callConversation11Labs;
      if (this.isCallEnded) {
        callConversation11Labs.endSession();
      }

      console.log("Call Conversation", this.callConversation);

      if (callConnectedSuccess) {
        this.conversationId = this.callConversation.getId();
        console.log("Conversation Id", this.conversationId);
        
        this.callSocket?.emit("data", {
          type: VoiceCallDataType.CallConversationConnectedData,
          data: {
            userId: this.userId,
            chatChannelId: this.chatChannelId,
            conversationId: this.conversationId,
          },
        });
      }
    }
  }
}

export default VoiceCallSocketServiceImpl;
